import React, { Component } from 'react'
import { connect } from 'react-redux'

import { SECTORES } from '../../../config/silos'
import * as actions from '../actions'
import Silos3dView from '../components/Silos3dView'
import { initialState } from '../reducers'

class Silos3d extends Component {
  constructor (props) {
    super(props)
    this.onSiloClicked = this.onSiloClicked.bind(this)
    this.onSectorSelected = this.onSectorSelected.bind(this)
    this.onUpdateHuds = this.onUpdateHuds.bind(this)
  }

  onSiloClicked (silo) {
    this.props.clickedSilo(silo)
  }

  onSectorSelected (sector) {
    this.props.clickedSector(sector)
  }

  onUpdateHuds (huds) {
    this.props.updateHuds(huds)
  }

  render () {
    const { data, isLoading, escalaDeRadio } = this.props.state
    return <Silos3dView data={data} isLoading={isLoading} escalaDeRadio={escalaDeRadio} onSiloClicked={this.onSiloClicked} sectores={SECTORES} onSectorSelected={this.onSectorSelected} updateHuds={this.onUpdateHuds} />
  }
}

const mapStateToProps = (state) => {
  return {
    state: state.vista3d.graficoState || initialState.graficoState
  }
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux(Silos3d)
